var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31319 1.14645C8.50846 0.951184 8.82504 0.951184 9.0203 1.14645L11.6453 3.77145C11.8406 3.96671 11.8406 4.28329 11.6453 4.47855C11.45 4.67382 11.1335 4.67382 10.9382 4.47855L8.66675 2.20711L6.3953 4.47855C6.20004 4.67382 5.88346 4.67382 5.68819 4.47855C5.49293 4.28329 5.49293 3.96671 5.68819 3.77145L8.31319 1.14645Z",
    fill: "#4A4C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 1C8.94289 1 9.16675 1.22386 9.16675 1.5V8.5C9.16675 8.77614 8.94289 9 8.66675 9C8.39061 9 8.16675 8.77614 8.16675 8.5V1.5C8.16675 1.22386 8.39061 1 8.66675 1Z",
    fill: "#4A4C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45964 6.29289C3.64718 6.10536 3.90153 6 4.16675 6H5.66675C5.94289 6 6.16675 6.22386 6.16675 6.5C6.16675 6.77614 5.94289 7 5.66675 7H4.16675L4.16675 13.5H13.1667V7H11.6667C11.3906 7 11.1667 6.77614 11.1667 6.5C11.1667 6.22386 11.3906 6 11.6667 6H13.1667C13.432 6 13.6863 6.10536 13.8739 6.29289C14.0614 6.48043 14.1667 6.73478 14.1667 7V13.5C14.1667 13.7652 14.0614 14.0196 13.8739 14.2071C13.6863 14.3946 13.432 14.5 13.1667 14.5H4.16675C3.90153 14.5 3.64718 14.3946 3.45964 14.2071C3.2721 14.0196 3.16675 13.7652 3.16675 13.5V7C3.16675 6.73478 3.27211 6.48043 3.45964 6.29289Z",
    fill: "#4A4C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconSmall);
export default __webpack_public_path__ + "static/media/share-icon-small.410cc73b84a77d7df933c6f924115396.svg";
export { ForwardRef as ReactComponent };